import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Grid, Button, Dropdown } from 'semantic-ui-react';
import InputCalendarRange from './InputCalendarRange';
import { namespaces } from '../../../constants/translation';

class DatePicker extends Component {
  static propTypes = {
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    filterName: PropTypes.string.isRequired,
    filterNameFrom: PropTypes.string.isRequired,
    filterNameTo: PropTypes.string.isRequired,
    hasSearch: PropTypes.bool,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    onResetRange: PropTypes.func.isRequired,
    onSetRange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    t: PropTypes.func,
  }
  static defaultProps = {
    hasSearch: false,
    headerText: 'Select Date Range',
    options: [],
    placeholder: 'Select Date Range',
    value: '',
  }
  static getPropsToState = (props) => {
    const value = props.value || '';
    const custom = props.value === 'custom';
    return {
      value,
      custom,
    };
  }
  constructor(props) {
    super(props);
    const state = DatePicker.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = DatePicker.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    this.setState({
      value,
      custom: value === 'custom',
    }, () => {
      this.props.onChange(value, this.props.filterName);
    });
  }
  handleClose = () => {
    this.setState({
      value: '',
    }, () => {
      this.props.onClose(this.props.filterName);
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          {
          this.state.custom ?
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <InputCalendarRange
                filterNameFrom={this.props.filterNameFrom}
                filterNameTo={this.props.filterNameTo}
                dateFrom={this.props.dateFrom}
                dateTo={this.props.dateTo}
                onClose={this.handleClose}
                onReset={this.props.onResetRange}
                onSetRange={this.props.onSetRange}
              />
            </Grid.Column>
            :
            <Grid.Column mobile={16} tablet={16} computer={16}>
              <Grid>
                <Grid.Row>
                  <Grid.Column width={14}>
                    <Dropdown
                      fluid
                      header={t(this.props.headerText)}
                      onChange={this.handleOnChange}
                      options={this.props.options}
                      placeholder={t(this.props.placeholder)}
                      search={this.props.hasSearch}
                      selection
                      selectOnBlur={false}
                      value={this.state.value}
                    />
                  </Grid.Column>
                  {
                    (this.state.value.length > 0 || (this.state.value.length > 0 && this.state.value !== 'custom')) &&
                    <Grid.Column width={2} verticalAlign="middle" className="clearicon">
                      <Button
                        as="a"
                        circular
                        icon="x"
                        onClick={this.handleClose}
                        size="mini"
                        title="Clear"
                      />
                    </Grid.Column>
                  }
                </Grid.Row>
              </Grid>
            </Grid.Column>
          }
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(DatePicker);



// WEBPACK FOOTER //
// ./src/components/Filters/DatePicker/DatePicker.jsx